import { Link } from "@tanstack/react-router";
import { Image } from "@/components/image";
import { Button } from "@/components/ui/button";
import {
  ScaffoldSection,
  ScaffoldSectionContainer,
  ScaffoldSectionContent,
  ScaffoldSectionHeader,
  ScaffoldSectionTitle,
} from "./scaffold";

export function History() {
  return (
    <ScaffoldSection className="relative z-0 bg-accent text-accent-foreground">
      <Image
        alt="Brick texture"
        className="-z-10 absolute top-0 left-0 w-1/4 max-w-40"
        height={220}
        src="/images/brick_texture.png"
        width={130}
      />
      <Image
        alt="Brick texture"
        className="-z-10 absolute right-0 bottom-0 w-1/4 max-w-40 rotate-180"
        height={220}
        src="/images/brick_texture.png"
        width={130}
      />
      <ScaffoldSectionContainer>
        <ScaffoldSectionHeader>
          <ScaffoldSectionTitle>Unsere Geschichte</ScaffoldSectionTitle>
        </ScaffoldSectionHeader>
        <ScaffoldSectionContent>
          <p className="w-full max-w-2xl text-center">
            Die Alte Papierfabrik Wuppertal kombiniert Freizeitspaß und Genuss
            in historischem Ambiente. Highlights sind die moderne Bowlingbahn,
            das beeindruckende 3D-Schwarzlicht-Minigolf und das Aposto
            Restaurant mit mediterraner Küche. Zudem ist die Location ein
            beliebter Event-Spot für Feiern und besondere Anlässe. Ein perfekter
            Ort für Spiel, Spaß und Genuss!
          </p>
          <Button
            asChild
            className="w-fit border-4 border-accent-foreground"
            size="xl"
            variant="unstyled"
          >
            <Link to="/historie">Weitere Informationen</Link>
          </Button>
        </ScaffoldSectionContent>
      </ScaffoldSectionContainer>
    </ScaffoldSection>
  );
}
